import { render, staticRenderFns } from "./fireResistantStructSpecTab.vue?vue&type=template&id=27991f24"
import script from "./fireResistantStructSpecTab.vue?vue&type=script&lang=js"
export * from "./fireResistantStructSpecTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27991f24')) {
      api.createRecord('27991f24', component.options)
    } else {
      api.reload('27991f24', component.options)
    }
    module.hot.accept("./fireResistantStructSpecTab.vue?vue&type=template&id=27991f24", function () {
      api.rerender('27991f24', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/psi/lbe/frss/fireResistantStructSpecTab.vue"
export default component.exports